export default __webpack_public_path__ + "static/media/jamie-logo.0c5435df.svg";